import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { QuickAction } from '../types';

interface QuickActionsProps {
  actions: QuickAction[];
}

const QuickActions = ({ actions }: QuickActionsProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card border border-border rounded-md shadow-elevation-1 p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {actions.map((action) => (
          <button
            key={action.id}
            onClick={() => navigate(action.route)}
            className="flex flex-col items-start gap-3 p-4 rounded-md border border-border hover:border-primary hover:bg-primary/5 transition-interactive text-left"
          >
            <div
              className="w-10 h-10 rounded-md flex items-center justify-center"
              style={{ backgroundColor: `${action.color}15` }}
            >
              <Icon name={action.icon} size={20} color={action.color} />
            </div>
            <div>
              <h3 className="text-sm font-medium text-foreground mb-1">
                {action.title}
              </h3>
              <p className="text-xs text-muted-foreground">{action.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;